import { Card, Icon, Loader, PageLayout, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import { getAppInfo } from 'utils/nativeSupport';
import { NavigateNext } from '@bharatpe/bharat-ui/web/Icons';
import { TriggerNativeApiWrapper } from 'utils/nativeUpiHandler';
import { API_URL } from 'Services/CONSTANT';
import Toasty from 'components/atoms/Toasty';
import thumbsUp from 'assets/icons/Autopay/thumbsUp.svg';
import history from 'utils/History';
import AppHeader from 'components/atoms/AppHeader';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import { WatchLaterRounded, WarningRounded, Cancel } from '@bharatpe/bharat-ui';
import './styles.scss';
import { sendEvent } from 'utils/Sentry';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const ManageAutoPayList: React.FC = () => {
	const [mandateListData, setMandateListData] = useState<any>();
	const [loading, setLoading] = useState(true);
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		(async () => {
			try {
				const data: any = await TriggerNativeApiWrapper(
					`${API_URL.all_mandates}?page_no=0&page_size=100`,
					'GET',
					{},
					getAppInfo() as any,
				);
				setLoading(false);
				setMandateListData(data?.mandates);
			} catch (err: any) {
				sendEvent(err);
				Toasty.error(err?.error || 'something went wrong');
			}
		})();
	}, []);

	const handleMandateClick = (mandateId: string) => {
		history.push({ pathname: '/account/auto-pay-details', search: `?mandateId=${mandateId}` });
	};

	const getStripDOM = (status: string, lastTransactionAmount: string) => {
		switch (status) {
			case 'ACTIVE':
			case 'HONORED':
				return (
					<>
						<img className="mr2" src={thumbsUp} height={12} width={12} />
						<Typography variant="Regular200" className="grey">
							₹{lastTransactionAmount} - {languageData.LAST_PAID}
						</Typography>
					</>
				);
			case 'PENDING':
			case 'INITIATED':
				return (
					<>
						<Icon icon={WatchLaterRounded} className={`pending-logo mr2`} height={14} width={14} />
						<Typography variant="Regular200" className="grey">
							{languageData.AUTOPAY_SETUP_IN_PROGRESS}
						</Typography>
					</>
				);
			case 'FAILED':
				return (
					<>
						<Icon icon={WarningRounded} className={`failed-logo mr2`} height={14} width={14} />
						<Typography variant="Regular200" className="grey">
							{languageData.UNABLE_TO_SET_UP_AN_AUTOPAY}
						</Typography>
					</>
				);
			case 'REVOKED':
				return (
					<>
						<Icon icon={Cancel} className={`grey-logo mr2`} height={14} width={14} />
						<Typography variant="Regular200" className="grey">
							{languageData.AUTOPAY_HAS_BEEN_CANCELLED}
						</Typography>
					</>
				);
		}
	};

	return loading ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background ">
			<>
				<AppHeader title={languageData.MANAGE_AUTO_PAY} />
				<div className="mx5 mt6 mandate-list text-center">
					{mandateListData &&
						mandateListData.map((item: any, index: number) => (
							<Card
								key={index}
								className="p4 mb5 mt5 flex flex-column flex-center mb4"
								onClick={() => handleMandateClick(item?.mandate_id)}>
								<div className="flex flex-row flex-justify flex-center width-100">
									<div className="flex flex-row">
										<img src={item?.payee_logo} className="circular-logo" />
										<div className="ml2 flex-start width-75">
											<Typography variant="Regular300" className="text-ellipsis1 text-left">
												{item?.payee_name}
											</Typography>
											<Typography variant="Regular200" className="grey mt1 text-ellipsis text-left">
												{item?.payee_vpa}
											</Typography>
										</div>
									</div>
									<Icon icon={NavigateNext} className="primary mr2" />
								</div>
								<div className="horizontal-dashed-divider my4"></div>
								<div className="flex flex-row flex-justify flex-center width-100">
									<div className="flex flex-row flex-center">
										{getStripDOM(item?.status, item?.last_transaction_amount)}
									</div>
								</div>
							</Card>
						))}
				</div>
				<div className="upi-powered-sticky">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};

export default ManageAutoPayList;
